import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContex";
import Profile from "../../profile/Profile";
import MenuItem from "./MenuItem";
import "./sidemenu.css";

export default function SideMenu(props) {
  const PS = process.env.REACT_APP_PUBLIC_SERVER;
  const { user } = useContext(AuthContext);

  const [inactive, setInactive] = useState(true);

  localStorage.getItem("user");

  const menuItems = [
    {
      name: "Sala de Negociação",
      to: "#/sala",
      iconClassName: "bi bi-bar-chart-line-fill",
    },
    {
      name: "Mercado",
      to: "javascript: void(0);",
      iconClassName: "bi bi-bank",
      subMenus: [
        { name: "Nacional", to: "#/mercado-nacional" },
        {
          name: "Internacional",
          to: "#/mercado-internacional",
          badgeClass:
            "badge rounded-pill badge-warning-lighten font-10 float-end",
          badgeValue: "vip",
        },
      ],
    },
    {
      name: "Noticias",
      to: "#/noticias",
      iconClassName: "bi bi-newspaper",
    },
    {
      name: "Chat",
      to: "#/chat",
      iconClassName: "bi bi-chat",
      badgeClass: "badge rounded-pill badge-primary-lighten font-10 float-end",
      badgeValue: "Prm",
    },
    {
      name: "Sociedade",
      to: "#/feed",
      iconClassName: "bi bi-people",
      badgeClass: "badge rounded-pill badge-warning-lighten font-10 float-end",
      badgeValue: "vip",
    },
    {
      name: "Meu Perfil",
      to: "#/perfil/" + user._id,
      iconClassName: "bi bi-person-circle",
    },
  ];

  useEffect(() => {
    if (inactive) {
      document.querySelectorAll(".sub-menu").forEach((el) => {
        el.classList.remove("active");
      });
    }
    props.onCollapse(inactive);
  }, [inactive]);

  const sighnOut = () => {
    localStorage.removeItem("user");
    window.location = "/";
  };

  return (
    <div className={`side-menu ${inactive ? "inactive" : ""}`}>
      <div className="top-section">
        <div className="logo">
          <img
            // onClick={() => setInactive(!inactive)}
            src={PS + "logo.png"}
            alt=""
          />
        </div>

        <div onClick={() => setInactive(!inactive)} className="toggle-menu-btn">
          {inactive ? "" : <i className="bi bi-arrow-left-square-fill"></i>}
        </div>
      </div>
      <div className="search-controller">
        <div>
          <button className="search-btn">
            <i class="bi bi-search"></i>
          </button>
        </div>
        <input type="text" placeholder="pesquisar" />
      </div>
      <div className="divider"></div>
      <div className="main-menu">
        <ul>
          {menuItems.map((menuitem, index) => (
            <MenuItem
              key={index}
              to={menuitem.to}
              name={menuitem.name}
              subMenus={menuitem.subMenus || []}
              iconClassNmae={menuitem.iconClassName}
              onClick={() => {
                if (inactive && menuitem.subMenus) {
                  setInactive(false);
                }
                if (menuitem.badgeClass == "prm") {
                }
              }}
              badgeClass={menuitem.badgeClass || null}
              badgeValue={menuitem.badgeValue || null}
            />
          ))}
          <li>
            <a className="menu-item" onClick={() => sighnOut()}>
              <div className="menu-icon">
                <i class="bi bi-power"></i>
              </div>
              <span>Terminar sessão</span>
            </a>
          </li>
        </ul>
      </div>
      <div className="side-menu-footer">
        <div className="avatar">
          <img
            src={
              user.imagemProfil
                ? PS + "users/" + user.imagemProfil
                : PS + "users/noavatar.jpg"
            }
            alt=""
          />
        </div>
        <div className="user-info">
          <h5>{user.username}</h5>
          <p>Iniciante</p>
        </div>
      </div>
    </div>
  );
}
